import { connect } from 'react-redux';
import { assign } from 'lodash';
import BaseForm from '../BaseForm/BaseForm';
import {
  updateAccessory,
  showError,
  clearErrors,
} from '../../redux/actions/accessories';

class AccessoryUpdateForm extends BaseForm {
  constructor(props) {
    super(props, {
      onSubmit: updateAccessory,
      name: 'Accessory',
      action: 'Update',
      type: 'update',
      isTypeForm: false,
    });
  }

  /**
   * Handle form validation
   */
  handleValidate(data, isIndex = (index: number) => true) {
    let result = data;
    if (this.props.model.didInvalidate) {
      this.props.dispatch(clearErrors());
    }
    if (isIndex(0) && BaseForm.validator.isEmpty(data.name)) {
      this.setState({ errors: ['name'] });
      this.props.dispatch(showError('Please specify a name'));
      return false;
    }
    if (data.image && data.image.length > 0) {
      const image = data.image[0];
      result = assign({}, data, { image });
      if (isIndex(2) && !BaseForm.validator.contains(image.type, 'image')) {
        this.setState({ errors: ['image'] });
        this.props.dispatch(showError('Please choose a valid image file'));
        return false;
      }
      if (isIndex(2) && image.size >= 5 * 1024 * 1024) {
        this.setState({ errors: ['image'] });
        this.props.dispatch(showError('Please choose an image under 5MB'));
        return false;
      }
    }
    if (isIndex(3) && !BaseForm.validator.isInt(`${data.limit}`)) {
      this.setState({ errors: ['limit'] });
      this.props.dispatch(showError('Please specify a valid limit'));
      return false;
    }
    if (isIndex(5) && !BaseForm.validator.isFloat(`${data.price}`)) {
      this.setState({ errors: ['price'] });
      this.props.dispatch(showError('Please specify a price'));
      return false;
    }
    if (
      isIndex(6) &&
      !BaseForm.validator.isFloat(`${data.additional_daily_price}`)
    ) {
      this.setState({ errors: ['additional_daily_price'] });
      this.props.dispatch(
        showError('Please specify an additional daily price'),
      );
      return false;
    }
    if (
      isIndex(7) &&
      !BaseForm.validator.isFloat(`${data.additional_weekly_price}`)
    ) {
      this.setState({ errors: ['additional_weekly_price'] });
      this.props.dispatch(
        showError('Please specify an additional weekly price'),
      );
      return false;
    }
    return result;
  }

  /**
   * Handle form reset
   */
  handleReset(dispatch, actions) {
    dispatch(actions.change('update.name', this.props.item.name));
    dispatch(actions.change('update.image', undefined));
    dispatch(
      actions.change('update.description', this.props.item.description || ''),
    );
    dispatch(actions.change('update.price', this.props.item.price || '0'));
    dispatch(
      actions.change(
        'update.additional_daily_price',
        this.props.item.additional_daily_price || '0',
      ),
    );
    dispatch(
      actions.change(
        'update.additional_weekly_price',
        this.props.item.additional_weekly_price || '0',
      ),
    );
    dispatch(
      actions.change('update.per_day', this.props.item.per_day || false),
    );
    dispatch(
      actions.change('update.featured', this.props.item.featured || false),
    );
    dispatch(
      actions.change('update.per_driver', this.props.item.per_driver || false),
    );
    dispatch(actions.change('update.limit', this.props.item.limit || '0'));
  }
}

const mapStateToProps = ({ accessories }) => ({
  model: accessories,
  fields: BaseForm.fields.accessories.update,
  values: {},
});

export default connect(mapStateToProps)(AccessoryUpdateForm);
